'use client';

import { useState, useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
import Link from 'next/link';

const COOKIE_NOTICE_KEY = 'starky-cookie-notice-v1-dismissed';

export function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const t = useTranslations('cookies');

  useEffect(() => {
    // DEBUG: Clear for testing PWA
    // try {
    //   localStorage.removeItem(COOKIE_NOTICE_KEY);
    // } catch (error) {
    //   console.error('Error clearing the cookie notice:', error);
    // }

    const dismissed = localStorage.getItem(COOKIE_NOTICE_KEY);
    if (!dismissed) {
      setShowBanner(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(COOKIE_NOTICE_KEY, 'true');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-background border-t border-border z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <div className="text-sm">
            <span className="text-muted-foreground">
              {t('essentialCookiesOnly')}
            </span>
            <Link
              href="/privacy"
              className="text-primary hover:underline ml-1"
            >
              {t('cookiePolicy')}
            </Link>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={handleDismiss}
            className="shrink-0"
          >
            {t('understood')}
          </Button>
        </div>
      </div>
    </div>
  );
}
